import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6abe42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "station-content" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_FTP",
  class: "col-sm-4 col-form-label",
  style: {"text-align":"right"}
}, "FTP User ID", -1 /* HOISTED */))
const _hoisted_8 = { class: "col-sm-5" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mb-3 row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-4" }, null, -1 /* HOISTED */))
const _hoisted_12 = {
  class: "col-sm-5",
  onchange: "validFTPUserId();",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_stationCode",
  class: "col-sm-4 col-form-label",
  style: {"text-align":"right"}
}, "Station Code", -1 /* HOISTED */))
const _hoisted_15 = { class: "col-sm-5" }
const _hoisted_16 = ["disabled", "value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "mb-3 row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-4" }, null, -1 /* HOISTED */))
const _hoisted_20 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_dataId",
  class: "col-sm-4 col-form-label",
  style: {"text-align":"right"}
}, "DATA ID", -1 /* HOISTED */))
const _hoisted_23 = { class: "col-sm-5" }
const _hoisted_24 = { class: "mb-3 row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-4" }, null, -1 /* HOISTED */))
const _hoisted_26 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_27 = { class: "mb-3 row" }
const _hoisted_28 = {
  class: "col-sm-6",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    ($setup.stationId == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode($setup["AdminNavigation"], { menuTile: $setup.title1 }, null, 8 /* PROPS */, ["menuTile"])
        ])),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            style: {"text-transform":"uppercase"},
            id: "txtFTPUserId",
            disabled: $setup.system != 'FTP',
            maxlength: "20",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.FTPUserId) = $event))
          }, null, 8 /* PROPS */, _hoisted_9), [
            [_vModelText, $setup.FTPUserId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString($setup.FTPUserIdError), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("select", {
            id: "ddlStationCode",
            class: "adjusting-position form-select select-style margin-left w-100",
            disabled: $setup.stationId != '',
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.stationChange($event))),
            value: $setup.selectedStationCode
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationCodeInfo, (info, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: info.stationCode
              }, _toDisplayString(info.stationCode) + " : " + _toDisplayString(info.companyName), 9 /* TEXT, PROPS */, _hoisted_17))
            }), 128 /* KEYED_FRAGMENT */))
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("span", _hoisted_20, _toDisplayString($setup.stationCodeError), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            style: {"text-transform":"uppercase"},
            id: "txtDataId",
            maxlength: "4",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dataId) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.dataId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", _hoisted_26, _toDisplayString($setup.dataIdError), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btnBackSystem",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.backbtnEvt()))
        }, " Back "),
        ($setup.stationId == '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary btnAddSystem",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.btnRegisterClick()))
            }, " Add "))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary btnAddSystem",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.btnRegisterClick()))
            }, " Update "))
      ]),
      _createElementVNode("span", _hoisted_28, _toDisplayString($setup.duplicateError), 1 /* TEXT */)
    ])
  ]))
}